export default __webpack_public_path__ + "static/media/octagons-no-1.81c61a40.mid";